import React from "react";
import Home from "../../../components/Home/Home";

const Match = () => {
  return (
    <div>
      <Home></Home>
    </div>
  );
};

export default Match;
